import { render, staticRenderFns } from "./ProductsServices.vue?vue&type=template&id=360e1774&scoped=true&"
import script from "./ProductsServices.vue?vue&type=script&lang=js&"
export * from "./ProductsServices.vue?vue&type=script&lang=js&"
import style0 from "./ProductsServices.vue?vue&type=style&index=0&id=360e1774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e1774",
  null
  
)

export default component.exports